import React from "react";
import styles from "./MediaPage.css";

const MediaPage = () => {
  return (
    <div className="container">
      <h1>My Media Collection</h1>

      <section
        className={styles.mediaPage_section}
        onClick={() => (window.location.href = "/spotify")}
      >
        <h2>Liked Songs</h2>
      </section>

      <section
        className={styles.mediaPage_section}
        onClick={() => (window.location.href = "/podcast")}
      >
        <h2>Favorite Podcasts</h2>
      </section>

      <section className={styles.mediaPage_section}>
        <h2>More Coming Soon</h2>
        <div className={styles.mediaPage_placeholder}>
          <p>Stay tuned for more exciting content!</p>
        </div>
      </section>
    </div>
  );
};

export default MediaPage;
